module.exports = __webpack_public_path__ + "static/img/fundamentals-icon-and-name.bb29a7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/tools/fundamentals-icon-and-name.png
// module id = fQa5
// module chunks = 0